// import { useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { singles as sings, albums as als } from './modules/Arrays';
import { processDownload } from './modules/Functions';
import Track from "./Track";

const Download = () => {
    const { track } = useParams();
    const history = useHistory();
    const song = processDownload(track, als, sings);


    return(
        <div className="musicals">
            <button onClick={history.goBack}>Back</button>
            {
                song ?
                <Track 
                    song={song} 
                    link={song.dl} 
                    download={true} /> 
        :

            <h3>404. Page Not Found</h3>
            }
            
        </div>
    )
}




export default Download;